// A stored website goes into an href only when it is an http(s) URL:
// anything else (javascript:, data:, ...) would run in the viewer's browser.
export const webUrl = (value) => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
};
